import React, {Component} from 'react';
import logo from './logo.svg';
//import './App.css';    **************** richtet alles rechts aus ?!
import {connect} from "react-redux";
import {WithTranslation, withTranslation} from 'react-i18next';
import SowHeader from './header/SowHeader'
import SowContent from './content/SowContent'
import SowFooter from './footer/SowFooter'
import {userLogout} from "./store/user/actions";
import {thunkUserLogin, thunkUserSave} from "./store/thunks";
import {UserState} from "./store/user/types";
import {AppState} from "./store";
import {RouteComponentProps, withRouter} from "react-router";
import {compose} from "redux";

// Component own properties
type AppProps = RouteComponentProps & WithTranslation & {
    thunkUserLogin: any;
    thunkUserSave: any;
    userLogout: typeof userLogout;
    user: UserState;
}

class App extends React.Component <AppProps> {
    render() {
        return (
            <div className="App">
                <div className="sowFrame">
                    <div className="sowPanel">
                        <SowHeader/>
                        <SowContent t={this.props.t}/>
                        <SowFooter/>
                    </div>
                </div>
                <button style={{marginRight: '10px'}} onClick={() => this.props.i18n.changeLanguage('de')}>de</button>
                <button onClick={() => this.props.i18n.changeLanguage('en')}>en</button>
            </div>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    user: state.user
});

export default compose(
    withRouter,
    withTranslation('common'),
    connect(
        mapStateToProps,
        {thunkUserLogin, userLogout, thunkUserSave}
    )
)(App) as any;

